import React, { useState, useEffect, useRef } from "react";
import WelcomeComponent from "../WelcomeComponent/WelcomeComponent";
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";
import QuestionComponent from "../QuestionComponent/QuestionComponent";
import QualificationComponent from "../Qualification/Qualification";
import { Sam } from "../Rive/RiveComponent";
import RankingComponent from "../RankingComponent/RankingComponent";
import styles from "./GameInProgress.module.css";

import { GameProvider } from "../GameContext";

import { ANIMATIONS } from "../../utils/constants";


import soundTrackApp from "../../assets/audios/SoundTrack.mp3";
import soundTrackRanking from "../../assets/audios/RankingSound.mp3";

const GameInProgress = ({ user, game, socket, room }) => {
  const [animation, setAnimation] = useState(1);
  const audioRef = useRef(null); // Referencia para el audio
  const playBtnRef = useRef(null);

  useEffect(() => {

    if (!audioRef.current) {
      return;
    }

    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;

    audioRef.current.addEventListener('loadedmetadata', () => {
      audioRef.current.muted = false;
    });

  }, [game.state]);

  //recibimnos un clip de animacion que mostrar
  //lo mostramos por un tiempo y despues pasamos al idle de regreso
  function PlayAnimation(clip, customTime = null) {
    if (clip != null) {
      console.log("animation::  ", clip);
      setAnimation(clip);
    } else {
      setAnimation(ANIMATIONS.talking);
    }

    var t = 2500;
    if (clip === ANIMATIONS.hello) { t = 4000; }
    if (clip === ANIMATIONS.celebrating) { t = 3000; }

    if (customTime) {
      t = customTime;
    }

    setTimeout(() => {
      setAnimation(ANIMATIONS.idle);
    }, t);
  }

  return (
    <GameProvider user={user} game={game} socket={socket} room={room}>
      <div id="clouds">
        <div className="cloud x1"></div>
        <div className="cloud x2"></div>
        <div className="cloud x3"></div>
        <div className="cloud x4"></div>
        <div className="cloud x5"></div>
      </div>
      <div className={styles.screen}>

        <div className={styles.imgSam}>
          <Sam animation={animation} />
        </div>

        {game.state !== '' &&
          <div className={styles.curtain}>
            <div className={styles.zigZagLineV}> </div>
          </div>
        }


        <div className={styles.gameInProgress}>
          {game.state === "welcome" && <WelcomeComponent playAnimation={PlayAnimation} />}
          {(game.state === "spinner" || game.state === "joker") && <SpinnerComponent playAnimation={PlayAnimation} />}
          {game.state === "in_round" && <QuestionComponent playAnimation={PlayAnimation} />}
          {game.state === "qualification" && <QualificationComponent playAnimation={PlayAnimation} />}
          {(game.state === "final_ranking" || game.state === "ranking" || game.state === "winner") && <RankingComponent playAnimation={PlayAnimation} />}
        </div>
      </div>
    </GameProvider>
  );
}

export default GameInProgress;